export const VIDEOPLAYER_ORIGIN = 'https://videoplayer.gg';
export const MUX_CONNECTED_MESSAGE = 'videoplayer:mux-connected';

// VideoPlayer.gg posts { type } to https://app.groove.cm after a successful connect.
// Never trust anything else in the payload: callers re-check status with GrooveAPI.
export function isMuxConnectedMessage(event) {
  return Boolean(
    event && event.origin === VIDEOPLAYER_ORIGIN && event.data && event.data.type === MUX_CONNECTED_MESSAGE
  );
}

export function isTrustedConnectUrl(url) {
  return typeof url === 'string' && url.indexOf(`${VIDEOPLAYER_ORIGIN}/`) === 0;
}

export function openMuxConnect(connectUrl, onConnected, win = window) {
  // Keep window.opener (no "noopener") so VideoPlayer.gg can post the connected message back.
  const popup = win.open(connectUrl, 'videoplayer-mux-connect', 'width=720,height=820');
  const listener = event => {
    if (isMuxConnectedMessage(event)) onConnected();
  };
  win.addEventListener('message', listener);
  return {
    popup,
    stop() {
      win.removeEventListener('message', listener);
    },
  };
}
